export enum TraitActionTypeEnum {
  TAP_TRAIT = 'TAP_TRAIT',
  TAP_PIERCING = 'TAP_PIERCING',
  TAP_PIERCING_COLOUR = 'TAP_PIERCING_COLOUR',
}
